<template>
  <article id="article-indices-quote">
    <!-- Indice Performance -->
    <section id="section-indices-intro">
      <performance-card
        data-action="follow_index"
        type="indice"
        :item="getIndiceQuote"
        v-if="typeof(getIndiceQuote) === 'object'"
      />
    </section>
    <!-- Indice Performance -->

    <section id="section-graph">
      <GraphNav
        v-if="getIndiceQuote.name && showGraph"
        :id="getIndiceQuote.name"
        @call-tradingview="chartModalTV(getIndiceQuote.name)"
      />
    </section>

    <section id="section-other-indice">
      <OtherIndice :exclude="getIndiceQuote.name" />
    </section>
  </article>
</template>
<script>
const GraphNav = () => import("../../../components/miniapp/indices/GraphNav");
const OtherIndice = () => import("../../../components/miniapp/indices/OtherIndice");
const PerformanceCard = () => import("../../../components/miniapp/global/PerformanceCard");

import { mapActions, mapGetters } from "vuex";
export default {
  metaInfo() {
    return {
      title: process.env.VUE_APP_NAME
    };
  },
  components: {
    PerformanceCard,
    GraphNav,
    OtherIndice
  },
  data() {
    return {
      showGraph: false,
      showChartCover: true,
      name: ""
    };
  },
  watch: {
    $route(newRoute) {
      this.name = newRoute.query.name;
    },
    async name(v) {
      this.showGraph = false
      await this.findIndiceQuote(v);
      let rs = await this.findStockGraphPeriod(this.getIndiceQuote.ID)
      this.showGraph = rs && this.getStockPeriod.default_period ? true : false
    }
  },
  computed: {
    ...mapGetters("indice", ["getIndiceQuote"]),
    ...mapGetters("stock", ["getStockPeriod"])
  },
  async mounted() {
    this.name = this.$route.query.name;
    await this.findIndiceQuote(this.name);
    let rs = await this.findStockGraphPeriod(this.getIndiceQuote.ID)
    this.showGraph = rs && this.getStockPeriod.default_period ? true : false
  },
  methods: {
    ...mapActions("indice", ["findIndiceQuote"]),
    ...mapActions("stock", ["findStockGraphPeriod"]),
    toggleChartCover() {
      this.showChartCover = !this.showChartCover;
    },
    chartModalTV(short_code) {
      this.$router.push({
        name: "miniapp-tradingview",
        query: { name: short_code, type: "indice" }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#article-indices-quote {
  #section-indices-intro {
    @extend %container-style;
    .intro-header {
      .intro-header-name {
        @include finCol(10, 12, 0px, top, true, true);
        h1 {
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          @extend %font-size-l;
          color: $color-normal-text;
        }
        p {
          margin: 0;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          @extend %font-size-s;
          color: $color-secondary-text;
        }
      }
      .intro-subscriber {
        @include finCol(2, 12, 0px, top, true, true);
        text-align: right;
        user-select: none;
        // .subscribe-btn {
        // }
      }
    }
    .intro-nav {
      .indices-nav {
        @extend %font-size-xxl;
        display: inline-block;
      }
      span {
        @extend %font-size-l;
        margin-left: 5px;
        display: inline-block;
        font-weight: bold;
      }
      .date-nav {
        margin: 0;
        @extend %font-size-s;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: $color-secondary-text;
      }
    }
  }
  // #section-graph {
  // }
}
</style>